import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import StringHelpers from '../helpers/StringHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import Utilities from '../helpers/Utilities'

export default class {
    static savePageValues(page) {
        
        if(!page.rowKey) {
            console.log('savePageValues > No row key provided')
        }

        const table = page.table || 'temp'
        const rowKey = page.rowKey 
        const scope = page.scope || 'local'
        
        let row = {}                          
        page.elements.forEach(element => { 
            row[element.fieldPos] = element.value
        })

        const ref = this.fbRef(this.tablePath(scope, table) + '/data/' + rowKey)

        ref.set(row)
        
        console.log('ScreenData > savePageValues saved to:', FirebaseHelpers.firebaseConsolePathFromRefString(ref.toString()))
    } 

    static pageToRecord(page) {
        let row = {}                          
        page.elements.forEach(field => {
            row[field.name] = field.value
        })     
        return row   
    }

    static tablePath(scope, table) {
        return 'tables' + '/' + scope + '/' + table
    }

    static globalTablePath (table) {
        return this.tablePath('global', table)
    }

    static fbRef(path) {
        return firebase.database().ref(path)
    } 

    static deleteRecord(scope, table, rowKey) {
        let ref = this.fbRef(this.tablePath(scope, table) ).child('data').child(rowKey)
        ref.remove()
    }

    static deleteRecordSafely(scope, table, rowKey) {
        let ref = this.fbRef(this.tablePath(scope, table) ).child('data').child(rowKey)
        ref.remove()
    }

    static saveFieldValue(scope, table, rowKey, fieldName, value) {

        const tableRef = this.fbRef(this.tablePath(scope, table) )
        const fieldRef = tableRef.child('fields').orderByChild('fieldName').equalTo(fieldName)
        fieldRef.once('value', snap => {
            let field = FirebaseHelpers.snapshotToObject(snap)
            if(field) {
                const storageKey = field.fieldPos
                console.log('storing to field called ' + storageKey)
                const dataRef = tableRef.child('data').child(rowKey).child(storageKey)
                console.log('saveFieldValue', dataRef.toString(), value)
                dataRef.set(value)
            }
        })
    }

    static injectTable(table, parameters) {
        // eg parameters: { scope: x, table: x, orderBy: x, startAt: x, endAt: x }

        return new Promise( (resolve, reject) => {
            const tablePath = this.tablePath(parameters.scope, parameters.table)
            const fieldRef = this.fbRef(tablePath + '/fields')
            let dataRef = this.fbRef(tablePath + '/data')

            const startTime = new Date()
            
            fieldRef.on('value', snap => {
            // Vue.set(parameters, 'data', {})
            const fields = this.snapshotToCollection(snap)
            
            Vue.set(table, 'fields', fields )

            if(parameters.orderBy) {
                const fbOrderBy = Utilities.getPropertySafely(table.fields.find(o => o.fieldName == parameters.orderBy), 'fieldPos')
                
                dataRef = dataRef.orderByChild(fbOrderBy) 
                if(parameters.startAt)
                    dataRef = dataRef.startAt(parameters.startAt)   
                if(parameters.endAt)
                    dataRef = dataRef.endAt(parameters.endAt)
            }

            dataRef = dataRef.limitToFirst(parameters.limit || 200)
            dataRef.on('value', snap => {
                const records = this.snapshotToArrayTranslated(snap, table.fields)
                Vue.set(table, 'records', records)
                const endTime = new Date()
                
                const result = {
                    path: FirebaseHelpers.firebasePathFromRefString(dataRef.toString()),
                    count: records.length,
                    time: (endTime - startTime).toString() + 'ms'
                }
                resolve(result)
            })

            }, error => {   
                console.error(error)
                reject(error)
                debugger
            })             
                    
         
        })

                  
    }

    static tableDataToDisplay(tableData) {
        let toArray = []
        tableData.records.forEach(record => {
            let properties = Object.keys(tableData.fields)
            let toObj = {}
            properties.forEach(property => {
                const value = record[property]
                const type = tableData.fields[property].type
                toObj[property] = this.formatForDisplay(value, type)
            })
            toArray.push(toObj)
        })

        return {
            fields: tableData.fields,
            records: toArray
        } 
    }
    // static tableDataToDisplay(tableData) {
    //     let toArray = []
    //     tableData.records.forEach(record => {
    //         let properties = Object.keys(record)
    //         let toObj = {}
    //         properties.forEach(property => {
    //             const value = record[property]
    //             const type = tableData.fields[property].type
    //             toObj[property] = this.formatForDisplay(value, type)
    //         })
    //         toArray.push(toObj)
    //     })

    //     return {
    //         fields: tableData.fields,
    //         records: toArray
    //     } 
    // }

    static formatForDisplay(value, type) {
        if(typeof value === 'undefined')
            return ''

        if(type == 'Date')
            return DateHelpers.backwardsToAu(value)
        if(type == 'Currency')
            return StringHelpers.formatCurrency(value)
        if(type == 'Contact')
            return ContactHelpers.fullName(value)
        return value
    }

    //Firebase stored format into array with translated property names...

    static snapshotToArrayTranslated(snap, fields) {
        let toArray = []
        snap.forEach(childSnapshot => {
            let toRecord = {}
            
            let fromRecord = childSnapshot.val()
            for(let prop in fromRecord) {
                const field = fields.find(o => o.fieldPos == prop)
                
                let value = fromRecord[prop]

                toRecord[field.fieldName] = value
            }
            toRecord.key = childSnapshot.key
            toArray.push(toRecord)
        })
        return toArray
    }

    static translateFields(fieldObject) {
        
        let toObject = {} 
        for(let prop  in fieldObject) { 
            let obj = {...fieldObject[prop]}
            let name = obj.name
            delete obj.name
            obj.fieldPos = prop
            obj.title = obj.title || StringHelpers.snakeToNormal(name)
            toObject[name] = obj 
        }
        return toObject
    }

    


    static createTableDataProperties() {
        return {
            scope: null,
            table: null,
            orderBy: null,
            startAt: null,
            endAt: null,
        }
    }

    static snapshotToCollection(snap) {
        let returnArr = []
        snap.forEach(childSnapshot => {
            let item = childSnapshot.val()
            item['.key'] = childSnapshot.key
            returnArr.push(item)
        })        
        return returnArr 
    }

}


// WEBPACK FOOTER //
// ./src/screens/ScreenData.js